import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

// spacer size
var navHeight = $('.nav_mobile_e3f1').height();
if(window.innerWidth < 783) {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight - 46 + 'px'})
} else {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight + 'px'})
}

function openMenu() {
  disableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').addClass('active');
  $('.nav_mobile_e3f1').addClass('active');
}

function closeMenu() {
  enableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').removeClass('active');
  $('.nav_mobile_e3f1').removeClass('active');
}

$('.nav_mobile_e3f1__trigger').on('click', function(e){
  e.preventDefault();
  if($(this).hasClass('active')) {
    closeMenu();
  } else {
    openMenu();
  }
});

$('.nav_mobile_e3f1__menu i').on('click', function(){
  var $li = $(this).parent();
  if($li.hasClass('active')) {
    $li.removeClass('active');
  } else {
    $li.addClass('active');
  }
});


window.addEventListener('load', function () {

  var coll = document.getElementsByClassName("mobile_nav__trigger");
for (var i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function(evnt) {
    const currClassList = evnt.target.classList;
    if (currClassList.contains('collapsed')) {
        evnt.target.classList.remove("collapsed");
        var content = evnt.target.nextElementSibling;
        content.style.maxHeight = null;
    } else {
      for (var j = 0; j < coll.length; j++) {
           coll[j].classList.remove("collapsed")
           coll[j].nextElementSibling.style.maxHeight = null;
      }
      this.classList.toggle("collapsed");
      var content = this.nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    }
  });
}
  
  var height_val = jQuery('.startopen').height();
  console.log("get con height 6: " + height_val );
  //jQuery('.startopen').css({"maxHeight": height_val + "px"});

});

